<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <input :id="id" ref="input" v-bind="$attrs" class="form-input" :class="{ error: error, req: req }" :type="type" :req="req" :value="value" @input="$emit('input', $event.target.value)" />
    <div v-if="req<1" class="text-xs text-red-600">El campo es requerido.</div>
    <div v-if="error=='validation.required'" class="form-error">Campo requerido* </div>
    <div v-if="error!='validation.required'" class="form-error">{{ error }}</div>

  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${this._uid}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    value: String,
    label: String,
    error: String,
    req: String, 
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
}
</script>
